<template>
  <div class="check-list">
    <b-form-checkbox-group v-model="checked">
      <ul class="list-items">
        <li
          v-for="({ value, message }, index) in items"
          :key="`${index}-${value}`"
          class="item"
        >
          <b-form-checkbox
            :value="value"
            unchecked-value=""
          >
            {{ message }}
          </b-form-checkbox>
        </li>
      </ul>
    </b-form-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'tos-options',
  props: {
    'value': {
      type: Array,
      required: true
    },
    'checkout': {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      checked: []
    }
  },
  mounted() {
    const signupTos = this.$store.state.config.config.data.signup_tos
    if (!signupTos) return
    for (const [value, item] of Object.entries(signupTos)) {
      if (this.useItem(item) && item.default_checked) {
        this.checked.push(value)
      }
    }
  },
  computed: {
    items() {
      const signupTos = this.$store.state.config.config.data.signup_tos
      if (!signupTos) return []
      const items = []
      for (const [value, item] of Object.entries(signupTos)) {
        if (this.useItem(item)) items.push({ value, message: item.message })
      }
      return items
    }
  },
  methods: {
    useItem(item) {
      if (this.checkout && item.checkout) {
        if (!item.checkout_anon_only) return true
        return !this.$store.getters['user/isLoggedIn']
      }
    }
  },
  watch: {
    checked() {
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style scoped lang="scss">
.check-list {
  ul.list-items {
    margin: -1em 0;
    padding: 0;
    list-style-type: none;

    li.item {
      margin: 0.3em 0;

     ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
        background-color: var(--main-primary);
      }

     ::v-deep label {
        font-size: 1.1em;
      }
    }
  }
}
</style>
